import {
  BuildJsonType,
  Country,
  EnhancedAppointment,
} from '@bb/domain/dist/types';
import * as React from 'react';
import { useReactToPrint } from 'react-to-print';
import styled from 'styled-components';
import Covid19AckTemplate from './COVID19AckTemplate';
import { AcknowledgmentModal } from './StyledComponents';

type AppointmentSignSettings = {
  covid19Signed?: string;
  template?: string;
};
interface Covid19SignedAckModalProps {
  appointment: BuildJsonType<EnhancedAppointment>;
  appointmentSignSettings: AppointmentSignSettings;
  country: Country;
  onCancel: () => void;
  visible: boolean;
}

const Covid19SignedAckModal: React.FC<Covid19SignedAckModalProps> = ({
  appointment,
  appointmentSignSettings,
  country,
  onCancel,
  visible,
}) => {
  const printAck = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => printAck.current,
  });

  return (
    <StyledModal
      centered
      open={visible}
      onCancel={onCancel}
      footer={null}
      zIndex={4001} // Needs to be bigger than TourListingModal to avoid overlap
    >
      <PrintModal ref={printAck}>
        <Covid19AckTemplate
          appointment={appointment}
          ackTemplate={appointmentSignSettings?.template}
          country={country}
        />
        <SignHereDiv>
          <img
            style={{ width: '50%', maxWidth: '200px' }}
            src={appointmentSignSettings?.covid19Signed}
            alt="signature"
          />
        </SignHereDiv>
      </PrintModal>
      <button
        onClick={handlePrint}
        className="btn btn-success"
        style={{ marginRight: '3em' }}
      >
        Print PDF
      </button>
    </StyledModal>
  );
};

const StyledModal = styled(AcknowledgmentModal).attrs({
  bodyStyle: {
    minHeight: '50vh',
    minWidth: '50vw',
    overflowY: 'auto',
    maxHeight: '85vh',
  },
})``;

const PrintModal = styled.div`
  @media print {
    padding: 0 40px;
  }
`;

const SignHereDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 0;
  * {
    margin-right: 6px;
  }
`;

export default Covid19SignedAckModal;
